'use strict';
var $iscapEmailEnable = $("#isEnableCapEmail");

if ($iscapEmailEnable.length > 0 && $iscapEmailEnable.val() === 'true' && $iscapEmailEnable.val() !== null) {
    var formUtils = require('./formUtils');
        formUtils.initCapEmailByForms();
}
